// Bootstrap confirm modal - zamiennik natywnego confirm()
// Obsługuje zarówno data-confirm (Rails UJS) jak i ręczne wywołania
;(function () {
  var MODAL_ID = 'bs-confirm-modal'

  function getOrCreateModal () {
    var existing = document.getElementById(MODAL_ID)
    if (existing) return existing

    var modal = document.createElement('div')
    modal.id = MODAL_ID
    modal.className = 'modal fade'
    modal.tabIndex = -1
    modal.innerHTML =
      '<div class="modal-dialog modal-dialog-centered modal-sm">' +
        '<div class="modal-content">' +
          '<div class="modal-body text-center py-4">' +
            '<div class="mb-3"><i class="fas fa-question-circle fa-3x text-warning"></i></div>' +
            '<p class="mb-0 fs-6" id="bs-confirm-message"></p>' +
          '</div>' +
          '<div class="modal-footer justify-content-center border-0 pt-0 pb-3">' +
            '<button type="button" class="btn btn-secondary px-4" data-bs-dismiss="modal">Nie</button>' +
            '<button type="button" class="btn btn-danger px-4" id="bs-confirm-yes">Tak</button>' +
          '</div>' +
        '</div>' +
      '</div>'
    document.body.appendChild(modal)
    return modal
  }

  // Promise-based confirm - do użycia w ręcznym JS
  window.bootstrapConfirm = function (message) {
    return new Promise(function (resolve) {
      var modalEl = getOrCreateModal()
      var msgEl = modalEl.querySelector('#bs-confirm-message')
      var yesBtn = modalEl.querySelector('#bs-confirm-yes')
      msgEl.textContent = message

      var bsModal = window.bootstrap.Modal.getOrCreateInstance(modalEl)
      var result = false

      function cleanup () {
        yesBtn.removeEventListener('click', onYes)
        modalEl.removeEventListener('hidden.bs.modal', onHidden)
      }

      function onYes () {
        result = true
        bsModal.hide()
      }

      function onHidden () {
        cleanup()
        resolve(result)
      }

      yesBtn.addEventListener('click', onYes)
      modalEl.addEventListener('hidden.bs.modal', onHidden)
      bsModal.show()
    })
  }

  // Override Rails UJS confirm - asynchroniczny, blokuje submit do decyzji
  if (window.Rails) {
    var originalConfirm = window.Rails.confirm
    window.Rails.confirm = function (message, element) {
      if (element.dataset.bsConfirmHandled === 'true') {
        element.dataset.bsConfirmHandled = ''
        return true
      }

      window.bootstrapConfirm(message).then(function (result) {
        if (result) {
          element.dataset.bsConfirmHandled = 'true'
          if (element.tagName === 'FORM') {
            element.requestSubmit ? element.requestSubmit() : element.submit()
          } else {
            element.click()
          }
        }
      })

      return false
    }
  }
})()
